/**
 * Accordion class
 *
 * Handles each individual accordion item.
 */
class Accordion {
	/**
	 * Constructor.
	 *
	 * @param {HTMLElement} domNode the accordion dom node
	 */
	constructor( domNode ) {
		this.accordion = domNode;

		// Ensure the same accordion is not instantiated more than once.
		if ( this.accordion.dataset.initiated ) {
			return;
		}

		this.button = this.accordion.querySelector( 'button[aria-expanded]' );

		const controlsId = this.button.getAttribute( 'aria-controls' );
		this.content = document.getElementById( controlsId );

		// Get initial open state.
		this.openState = this.button.getAttribute( 'aria-expanded' ) === 'true';

		// add event listeners
		this.button.addEventListener( 'click', this.onButtonClick );

		// Set this as having been initiated.
		this.accordion.dataset.initiated = true;
	}

	/**
	 * Run on clicking the button.
	 *
	 * @param {Event} event The event triggered with the click.
	 */
	onButtonClick = event => {
		event.preventDefault();
		this.toggle( ! this.openState );
	};

	/**
	 * Toggle open/closed state of the accordion.
	 *
	 * @param {boolean} openState Open state of the accordion.
	 */
	toggle = openState => {
		// don't do anything if the openState state doesn't change.
		if ( openState === this.openState ) {
			return;
		}

		// Toggle active class on the parent.
		this.accordion.classList.toggle( 'active' );

		// update the internal state
		this.openState = openState;

		// handle DOM updates
		this.button.setAttribute( 'aria-expanded', openState );
		if ( openState ) {
			this.toggleOpenState();
		} else {
			this.toggleClosedState();
		}
	}

	/**
	 * Toggle its open state.
	 */
	toggleOpenState = () => {
		this.content.removeAttribute( 'hidden' );
		this.content.style.maxHeight = `${ this.content.scrollHeight }px`;
	}

	/**
	 * Toggle its closed state.
	 */
	toggleClosedState = () => {
		this.content.style.maxHeight = null;
		this.content.setAttribute( 'hidden', '' );
	}
}

// Initiate our class instance for each accordion.
const accordions = document.querySelectorAll( '.wp-block-qala-blocks-single-accordion' );
accordions.forEach( accordion => {
	new Accordion( accordion );
} );
